import React from 'react'
import { CustomButton } from '../../../../components'

interface RadioButtonProps {
    onClick: () => void
    children: React.ReactNode
    selected?: boolean
    disabled?: boolean
}

export const RadioButton = React.forwardRef<HTMLButtonElement, RadioButtonProps>(
    ({ children, selected, onClick, disabled }, ref) => {
        return (
            <CustomButton onClick={onClick} disabled={disabled} isActive={selected} ref={ref}>
                {children}
            </CustomButton>
        )
    }
)

RadioButton.displayName = 'RadioButton'
